import { Location, locationName } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const MonitoringPage = lazy(() => import('@cobliteam/monitoring/src/pages/MonitoringPage'));
const MonitoringPageV2 = lazy(() => import('@cobliteam/monitoring/src/pages/MonitoringPageV2/MonitoringPageV2'));

const routes = [
  {
    title: locationName[Location.MONITORING],
    path: Location.MONITORING,
    component: MonitoringPage,
    needsGoogleMaps: true,
  },
  {
    title: locationName[Location.MONITORING_V2],
    path: Location.MONITORING_V2,
    component: MonitoringPageV2,
    featureFlag: 'monitoringV2',
    needsGoogleMaps: true,
  },
];

export default routes;
